import React from 'react';
import { Container, Typography } from '@mui/material';

const Students: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1">
        My Students
      </Typography>
      {/* Implement students list */}
    </Container>
  );
};

export default Students;
